export const COLUMN_HEADINGS = ['fanDatabase-table-email', 'fanDatabase-table-full-name', 'fanDatabase-table-options'];

export const COLUMN_MIN_WIDTH = [260, 350, 515];
